import React, { useEffect, useState, useContext } from "react";
import { useQuery } from 'react-query';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { getRejectedApplications } from '../../../api/apiServices';
import Pagination from '../../../services/Pagination';
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast, { Toaster } from 'react-hot-toast'

import AuthContext from "../../../context/AuthProvider";

const DeclinedApplications = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const { auth } = useContext(AuthContext)
    const params = useParams();
    const id = params.id ? params.id : undefined

    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(15);

    const {
        isLoading,
        isError,
        error,
        data: declinedApplications,
    } = useQuery(['declinedApplications', auth.email], () => getRejectedApplications(auth.email), {
        select: data => data.sort((a, b) => b.id - a.id),
        keepPreviousData: true,
    });

    let total_applications = declinedApplications?.length

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/regional_approvals";

    const indexOfLastPage = currentPage * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPosts = declinedApplications?.slice(indexOfFirstPage, indexOfLastPage);

    let content
    if (isLoading) {
        content = <p>Loading Regional Applications...</p>
    }
    else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            currentPosts && currentPosts?.length <= 0 ? (

                <div className="table-responsive lg">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ fontSize: "20px", fontWeight: "700", color: "#000", textAlign: "center" }}>
                                    There are no declined application(s)
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                    <div className="table-responsive lg">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" style={{ textAlign: 'center' }} >#</th>
                                    <th scope="col">Full Name</th>
                                    <th scope="col">Region</th>
                                    <th scope="col">Reason for Rejection</th>
                                    <th scope="col">Telephone</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPosts?.map((mem, index) =>
                                    <tr key={index}>
                                        <td>{postPerPage * (currentPage - 1) + index + 1}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{mem.title}&nbsp;{mem.first_name}&nbsp;{mem.middle_name}&nbsp;{mem.last_name}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{mem.region}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{mem.regional_approval_rejection_reason}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{mem.mobile_number}</td>
                                        <td>{mem.email}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>
                                            <div style={{ display: 'inline-block' }}>
                                                <Link to={`/dop_approve_form/${mem.id}`} className="small"><i className='fa fa-eye'></i> Review</Link>
                                            </div>&nbsp; &nbsp;
                                            <div style={{ display: 'inline-block' }}>
                                                <Link to={`delete_record/${mem.id}`} className="small"><i className='fa fa-trash'></i> Delete</Link>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )
    }

    return (
  <><section className="content-header">
            <Toaster toastOptions={{ position: "top-center" }} />
            <h1>Applications : Declined Applications - {total_applications}</h1>
        </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-9">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span> Declined Applications</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                {currentPosts?.length > 0 ? (

                                    <Pagination
                                        data={declinedApplications}
                                        postPerPage={postPerPage}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        setPostPerPage={setPostPerPage}
                                    />

                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="box-footer"></div>
                </div>
            </section>

</>
            );

}

            export default DeclinedApplications

